export enum FontFamily {
  HarmoniaSansStd = "HarmoniaSansStd",
  HarmoniaSansPro = "HarmoniaSansPro",
}

export enum FontWeight {
  Light = "300",
  Normal = "400",
  Medium = "500",
  SemiBold = "600",
  Bold = "700",
  ExtraBold = "800",
  Black = "900",
}
